<template>
  <div id="home">
    <van-nav-bar
      :title="$t('ShopSet.editBook')"
      left-arrow
      fixed
      @click-left="$router.push('/ShopSet/' + sessionStorage.actShopId)"
    >
    </van-nav-bar>
    <template v-if="activeStore == 0">
      <p class="text">{{ $t("EditBook.text") }}</p>
    </template>
    <template v-else>
      <!-- <div class="codeText">{{$t('EditBook.codeText')}}</div> -->
      <van-cell
        v-if="bookVal == '1' || bookVal == '0'"
        :title="$t('EditBook.bookSwitch')"
      >
        <van-switch
          :value="bookVal == '1'"
          @input="changeBookVal"
          active-color="#2f75f7"
          inactive-color="#ee0a24"
        />
      </van-cell>
      <van-cell
        v-if="takeaway == '1' || takeaway == '0'"
        :title="$t('EditBook.takeawaySwitch')"
      >
        <van-switch
          :value="takeaway == '1'"
          @input="changeTakeaway"
          active-color="#2f75f7"
          inactive-color="#ee0a24"
        />
      </van-cell>
      <van-cell
        v-if="menu == '1' || menu == '0'"
        :title="$t('EditBook.menuSwitch')"
      >
        <van-switch
          :value="menu == '1'"
          @input="changeMenu"
          active-color="#2f75f7"
          inactive-color="#ee0a24"
        />
      </van-cell>
      <van-cell
        v-if="pack == '1' || pack == '0'"
        :title="$t('EditBook.pickSwitch')"
      >
        <van-switch
          :value="pack == '1'"
          @input="changePack"
          active-color="#2f75f7"
          inactive-color="#ee0a24"
        />
      </van-cell>
      <van-image
        class="noInput"
        width="100%"
        height="150"
        fit="contain"
        :src="data.book_qrcode + '?time=' + clickTime"
      />
      <van-field
        class="noInput"
        readonly
        :label="$t('CookInfo.loginLink')"
        :value="data.book_link"
        type="textarea"
        autosize
      />
      <div class="wrapper">
        <span class="textWrapper">{{ $t("EditBook.copy") }}:</span>
        <div class="refresh" @click="copy()">{{ $t("EditBook.copyBtn") }}</div>
      </div>
      <div class="wrapper">
        <span class="textWrapper">{{ $t("EditBook.refresh") }}:</span>
        <div class="refresh" @click="refreshBookCode()">
          {{ $t("EditBook.refreshBtn") }}
        </div>
      </div>
    </template>
    <div class="shopList_wrap">
      <div class="shopList">
        <div class="shoptitle">
          <div style="padding-bottom: 10px;">
            {{ $t("platform.shopList") }}
          </div>
          <div>
            <van-icon name="add-o" @click="$router.push('/PlatformBind')" />
            <!-- <van-icon
              name="./static/img/add_staff.png"
              @click="$router.push('/PlatformBind')"
            ></van-icon> -->
          </div>
          <!-- <div class="refresh" >{{ $t("ShopList.add") }}</div> -->
        </div>
        <template v-for="(shop, index) in shops">
          <van-cell center :title="shop.name" @click="goShop(shop.link)">
            <template #icon>
              <van-icon
                :name="shop.image"
                size="65"
                style="margin-right: 10px"
              />
            </template>
            <template slot="right-icon">
              <div class="tagSort">
                <van-icon
                  @click.stop="onAction(shop.id, 'down')"
                  size="25px"
                  name="./static/img/down1.png"
                />
                <van-icon
                  @click.stop="onAction(shop.id, 'up')"
                  size="25px"
                  name="./static/img/up.png"
                />
                <van-icon
                  @click.stop="unBind(shop.id)"
                  size="25px"
                  name="./static/img/minus.png"
                />
                <van-icon
                  name="arrow"
                  size="25px"
                  @click.stop="goShop(shop.link)"
                />
              </div>
            </template>
          </van-cell>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      clickTime: 0,
      book: "book",
      activeStore: "",
      data: {},
      bookVal: "", //开关值
      takeaway: "", //开关值
      menu: "", //开关值
      pack: "",
      shops: []
    };
  },
  mounted() {
    this.getQRcode();
    this.getShop();
    this.getShops();
    this.activeStore = sessionStorage.getItem("activeStore");
  },
  methods: {
    //获取二维码
    getQRcode() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url:
          this.$build + "/api/store/" + sessionStorage.actShopId + "/bookQrcode"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.data = res.data.data;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("EditBook.message")
          });
        });
    },
    getShop() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/store/" + sessionStorage.actShopId + "/show"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.bookVal = res.data.data.book || 0;
            this.takeaway = res.data.data.takeaway || 0;
            this.menu = res.data.data.menu || 0;
            this.pack = res.data.data.is_pack || 0;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("EditShop.message")
          });
        });
    },
    //刷新二维码
    refreshCode(category) {
      this.$dialog
        .confirm({
          title: this.$t("SetSeat.refresh"),
          message: this.$t("SetSeat.refreshTip"),
          confirmButtonColor: "#2f75f4",
          confirmButtonText: this.$t("vantText.confirm"),
          cancelButtonText: this.$t("vantText.cancel")
        })
        .then(() => {
          this.$axios({
            method: "PATCH",
            headers: {
              Authorization: "Bearer " + sessionStorage.token
            },
            url:
              this.$build +
              "/api/store/" +
              sessionStorage.actShopId +
              "/refresh",
            data: {
              category: category
            }
          })
            .then(res => {
              console.log(res);
              if (res.data.status == 200) {
                this.clickTime = this.clickTime + 1;
                this.getQRcode();
                this.$toast({
                  type: "success",
                  message: res.data.message
                });
              } else {
                for (var item in res.data.error) {
                  this.$toast({
                    type: "fail",
                    message: res.data.error[item]
                  });
                }
              }
            })
            .catch(err => {
              this.$toast({
                type: "fail",
                message: this.$t("EditBook.message")
              });
            });
        })
        .catch(() => {});
    },
    refreshBookCode() {
      this.refreshCode(this.book);
    },
    getShops() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url:
          this.$build +
          `/api/promo/${sessionStorage.getItem("actShopId")}/index`
      })
        .then(res => {
          console.log(res.data.data);
          if (res.data.status == 200) {
            this.shops = res.data.data;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("ShopList.message")
          });
        });
    },
    onAction(id, type) {
      this.$axios({
        method: "post",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/promo/order",
        data: {
          id: id,
          action: type // 动作：【up：上移，down：下移】
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.shops = res.data.data;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("ShopList.message")
          });
        });
    },
    // 解绑
    unBind(id) {
      this.$axios({
        method: "DELETE",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + `/api/promo/${id}/destroy`,
        data: null
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.$toast({
              type: "success",
              message: "解绑成功"
            });
            // this.shops=res.data.data;
            this.getShops();
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("ShopList.message")
          });
        });
    },
    goShop(link) {
      if (link) {
        window.open(link);
      }
    },
    //复制链接
    copy() {
      //复制当剪切板
      let transfer = document.createElement("input");
      document.body.appendChild(transfer);
      transfer.value = this.data.book_link; // 这里表示想要复制的内容
      transfer.focus();
      transfer.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
      }
      transfer.blur();
      document.body.removeChild(transfer);
      this.$toast({
        duration: 800,
        type: "success",
        message: this.$t("CookInfo.copyScuess")
      });
    },
    async changeBookVal() {
      let val = this.bookVal == "1" ? "0" : "1";
      let data = {
        book: val
      };
      let ret = await this.changeVal(data);
      if (ret.status == 200) {
        this.bookVal = val;
      }
    },
    async changeTakeaway() {
      let val = this.takeaway == "1" ? "0" : "1";
      let data = {
        takeaway: val
      };
      let ret = await this.changeVal(data);
      if (ret.status == 200) {
        this.takeaway = val;
      }
    },
    async changeMenu() {
      let val = this.menu == "1" ? "0" : "1";
      let data = {
        menu: val
      };
      let ret = await this.changeVal(data);
      if (ret.status == 200) {
        this.menu = val;
      }
    },
    async changePack() {
      let val = this.pack == "1" ? "0" : "1";
      let data = {
        is_pack: val
      };
      let ret = await this.changeVal(data);
      if (ret.status == 200) {
        this.pack = val;
      }
    },
    changeVal(data) {
      return new Promise((resolve, reject) => {
        this.$axios({
          method: "PATCH",
          headers: {
            Authorization: "Bearer " + sessionStorage.token
          },
          url:
            this.$build + "/api/store/" + sessionStorage.actShopId + "/update",
          data: data
        })
          .then(res => {
            console.log(res);
            if (res.data.status == 200) {
              this.$toast({
                type: "success",
                message: res.data.message
              });
              resolve(res);
            } else {
              this.$toast.allowMultiple();
              for (var item in res.data.error) {
                this.$toast({
                  type: "fail",
                  message: res.data.error[item]
                });
              }
            }
          })
          .catch(err => {
            reject(err);
            this.$toast({
              type: "fail",
              message: this.$t("EditShop.message")
            });
          });
      });
    }
  }
};
</script>
<style scoped>
.shopList_wrap {
  /* border: 1px solid red; */
  padding: 0 16px;
  /* margin-top: 50px; */
}

.home {
  width: 100%;
  min-height: 100vh;
  background: #f3f3f3;
}
.shopList {
  padding-top: 20px;
}
.shoptitle {
  display: flex;
  justify-content: space-between;
  /* background: black; */
  padding-top: 4px;
}
/deep/ .van-grid-item__content p {
  font-size: 12px;
  text-align: center;
  margin: 0;
  padding: 0;
}
/deep/ .van-grid-item__content {
  padding: 0;
  border-radius: 5px;
  padding-bottom: 10px;
  align-items: center;
  -webkit-align-items: center;
  justify-content: flex-start;
}
.van-grid-item__content p.shopname {
  font-size: 15px;
}
.shopname1 {
  height: 36px;
  align-items: center;
  display: inline-flex;
}
.shopname {
  line-height: 18px;
  align-items: center;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.shoptime {
  font-size: 12px;
  color: #d4d4d4;
}
.shoptime span {
  color: rgb(253, 63, 63);
}
.van-image {
  align-items: center;
  -webkit-align-items: center;
}
.van-image__img {
  vertical-align: middle;
}
.shopIcon {
  margin: 10px 0;
}
.shopBj {
  width: 100%;
  border-radius: 5px 5px 0 0;
  text-align: center;
}
.tagSort {
  width: 110px;
  /*width: 86px;*/
  display: flex;
  justify-content: space-around;
}
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
.home {
  width: 100%;
  background: #f3f5f7;
  padding-bottom: 60px;
}
.codeText {
  margin-top: 20px;
  margin-left: 20px;
}
.refresh {
  width: 120px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 15px;
  background: #2f75f7;
  color: #fff;
  margin: 10px auto;
  margin-right: 10px;
}
.text {
  text-align: center;
  font-size: 20px;
}
.noInput {
  background-color: #f3f5f7;
  margin-top: 5px;
}
.wrapper {
  display: flex;
  padding: 0 16px;
}
.textWrapper {
  line-height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/Shop/EditBook.vue